import React from "react";
import { ArrowUp, ArrowDown, Minus, Circle } from "lucide-react";

const iconMap = {
  ArrowUp: <ArrowUp color="green" size={16} />,
  ArrowDown: <ArrowDown color="red" size={16} />,
  Minus: <Minus color="gray" size={16} />,
  Circle: <Circle color="orange" size={16} />,
};

const formatNumber = (val) => {
  if (typeof val === "number") return val.toFixed(2);
  return val;
};

const SignalTable = ({ data }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return <div>No data available</div>;
  }

  const columns = ["Security", "Close", "SuperTrend", "MACD", "Stochastic RSI", "Bollinger", "Summary"];

  const renderIndicator = (indicator, type) => {
    if (!indicator) return null;

    let tooltip = "";

    if (type === "stoch" && indicator.value.k !== undefined && indicator.value.d !== undefined) {
      tooltip = `K: ${formatNumber(indicator.value.k)}, D: ${formatNumber(indicator.value.d)}`;
    } else if (type === "bollinger") {
      if (indicator.value.upper !== undefined) tooltip = `Upper: ${formatNumber(indicator.value.upper)}, Lower: ${formatNumber(indicator.value.lower)}`;
      else if (indicator.value.lower !== undefined) tooltip = tooltip + `, Lower: ${formatNumber(indicator.value.lower)}`;
      else if (indicator.value.mid !== undefined) tooltip = tooltip + `, Mid: ${formatNumber(indicator.value.mid)}`;
    } else if (indicator.value !== undefined) {
      tooltip = formatNumber(indicator.value);
    }

    return (
      <span title={tooltip}>
        {iconMap[indicator.icon]} {indicator.text}
      </span>
    );
  };

  return (
    // <div>
          <div className="table-container">

      {/*<table border="1" cellPadding="6" cellSpacing="0" style={{ borderCollapse: "collapse", width: "100%" }}>*/}
              <table className="data-table">

        <thead style={{ background: "#f0f0f0" }}>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx} style={{ textAlign: "left", padding: "8px" }}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td>
                {/*<a href={`/stock/${row.security}`} style={{ color: "lawngreen", textDecoration: "none" }}>*/}
                <a href={`/stock/${row.security}`}>
                  {row.security}
                </a>
              </td>
              <td>{formatNumber(row.close)}</td>
              <td>{renderIndicator(row.superTrend)}</td>
              <td>{renderIndicator(row.macd)}</td>
              <td>{renderIndicator(row.stoch, "stoch")}</td>
              <td>{renderIndicator(row.bollinger, "bollinger")}</td>
              <td>
                <span
                  style={{
                    padding: "4px 8px",
                    borderRadius: "6px",
                    backgroundColor:
                      row.summary.text === "Strong Buy"
                        ? "#006400" // dark green
                        : row.summary.text === "Buy"
                        ? "#32cd32" // light green
                        : row.summary.text === "Strong Sell"
                        ? "#8b0000" // dark red
                        : row.summary.text === "Sell"
                        ? "#ff6347" // light red
                        : "#808080", // neutral gray
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  {row.summary.text}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SignalTable;

